import getMessageTypes from './get-message-types';
import getChannels from './get-channels';

export default {
	getMessageTypes,
	getChannels
};
